import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-watchlist',
  templateUrl: './watchlist.component.html',
  styleUrls: ['./watchlist.component.scss']
})

export class WatchlistComponent implements OnInit {
  public watchlist:Course[];
  public watchlistLoaded:boolean=false;
  public breadcrumbLinks=[];
  public thisPage:string='Your Watchlist';
  public image:string='';
  public title:string='';
  public blurb:string='';
  // TimeZone
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;

  constructor(
    private _course: CourseService,
    private timezoneService: TimeZoneService
  ) { }

  removeFromWatchlist(courseId:number){
    this._course.removeFromWatchlist(courseId).subscribe(
      (res:any)=>{
        if(res.message=='success') {
          this.watchlist.forEach((course, index)=>{
            if(course.id==courseId) return this.watchlist.splice(index,1);
          });
        }
      }
    );
  }

  ngOnInit() {
    this._course.getuserWatchlist(9999).subscribe(
      res=>{
        this.watchlist=res;
        this.watchlistLoaded=true;
      }
    );
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
  }

}
